import { Component, Sprite, _decorator } from 'cc';
import MultiThemeSprite from '../../../../../common/scripts/Toolkit/Components/MultiTheme/MultiThemeSprite';
import { RoadmapItemData } from '../../../Data/Strategy/RoadmapLayout/BaseRoadmapLayoutStrategy';

const { ccclass } = _decorator;

@ccclass('RoadmapItem')
export default abstract class RoadmapItem extends Component {
    private _multiThemeSprite: MultiThemeSprite = null;
    private _displayData: RoadmapItemData = null;
    protected declare abstract sprite: Sprite;

    public get displayData() {
        return this._displayData;
    }

    protected get multiThemeSprite() {
        if (!this._multiThemeSprite) {
            this._multiThemeSprite = this.sprite.getComponent(MultiThemeSprite);
        }
        return this._multiThemeSprite;
    }

    public display(data: RoadmapItemData) {
        if (!data || this._displayData === data) {
            return;
        }
        this._displayData = data;
        this.multiThemeSprite.theme = data.type;
    }
}
